import React, { FC } from 'react';

import { CloseSIcon } from '@gem/icons';

import styles from './ChipsItem.styles.m.css';
import { IChipsItem } from './ChipsItem.types';

export * from './ChipsItem.types';

interface IChipsItemProps {
  item: IChipsItem;
  onRemove(item: IChipsItem): void;
}

// TODO: вынести аватар на проетный уровень

export const ChipsItem: FC<IChipsItemProps> = ({ item, onRemove }) => {
  return (
    <div className={styles.container}>
      {item.prefix}
      {/*<Avatar*/}
      {/*  type={AvatarTypes.Round_0}*/}
      {/*  title={item.avatarTitle}*/}
      {/*  url={item.avatarUrl}*/}
      {/*  backgroundColorIndex={item.avatarColorIndex}*/}
      {/*/>*/}
      <div className={styles.title}>{item.title}</div>
      <button
        onClick={(): void => onRemove(item)}
        className={styles.removeContainer}
      >
        <CloseSIcon className={styles.removeIcon} />
      </button>
    </div>
  );
};
